import { useCallback, useState } from "react";
/**
 * 드롭다운 위치 계산 훅
 * fixed 포지셔닝으로 화면 밖으로 잘리지 않도록 위치 계산
 */ export const useDropdownPosition = function() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { dropdownWidth =138 , gap =6 , screenPadding =16  } = options;
    const [position, setPosition] = useState({
        top: 0,
        left: 0
    });
    const updatePosition = useCallback((buttonElement)=>{
        if (!buttonElement) return;
        const rect = buttonElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        // 버튼 중앙에 드롭다운 정렬
        const buttonCenter = rect.left + rect.width / 2;
        let left = buttonCenter - dropdownWidth / 2;
        // 화면 왼쪽을 넘어가면 왼쪽 정렬
        if (left < screenPadding) {
            left = screenPadding;
        }
        // 화면 오른쪽을 넘어가면 오른쪽 정렬
        if (left + dropdownWidth > viewportWidth - screenPadding) {
            left = Math.max(screenPadding, viewportWidth - dropdownWidth - screenPadding);
        }
        setPosition({
            top: rect.bottom + gap,
            left
        });
    }, [
        dropdownWidth,
        gap,
        screenPadding
    ]);
    return {
        position,
        updatePosition
    };
};
